import { Reveal, Eyebrow } from "./Reveal";
import { GALLERY } from "../../data/site";
import { useLang } from "../../i18n/LanguageContext";

const ALTS = [
  "Sunbeds and cabanas on the sand at Tribe Beach Lounge, Tigaki, Kos",
  "Turquoise Aegean water at Tigaki beach, Kos, Greece",
  "Beach bar cocktails at sunset, Tribe Beach Lounge Kos",
  "Private daybeds under timber pergolas at Tribe Beach, Tigaki",
  "Aerial view of Tribe Beach Lounge on Tigaki beach, Kos",
  "Family beach day at Tribe Beach Lounge, Kos",
];

export const Gallery = () => {
  const { t } = useLang();
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="py-24 md:py-36 bg-secondary/40"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <Reveal className="mb-12 max-w-xl">
          <Eyebrow>{t.gallery.eyebrow}</Eyebrow>
          <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl mt-5 leading-tight">
            {t.gallery.title}
          </h2>
        </Reveal>

        <div className="columns-2 md:columns-3 gap-3 md:gap-4 [&>*]:mb-3 md:[&>*]:mb-4">
          {GALLERY.map((src, i) => (
            <Reveal key={i} delay={(i % 3) * 0.1} className="overflow-hidden group break-inside-avoid">
              <img
                data-testid={`gallery-image-${i}`}
                src={src}
                alt={ALTS[i % ALTS.length]}
                className={`w-full object-cover group-hover:scale-105 transition-transform duration-700 ${
                  i % 3 === 0 ? "h-[420px]" : "h-[300px]"
                }`}
              />
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
